const videos = [
  {
    seq: 'media-01',
    title: '顶流明星恋情大曝光！深夜密会神秘女子全程被拍',
    views: '128.6万',
    time: '2小时前',
    duration: '03:25',
    tag: '娱乐圈',
    image: 'https://readdy.ai/api/search-image?query=Entertainment%20gossip%20video%20thumbnail%20style%20with%20bold%20text%20overlay%2C%20dramatic%20lighting%2C%20celebrity%20news%20visual%2C%20warm%20coral%20and%20amber%20tones%2C%20eye-catching%20headline%20design%2C%20modern%20social%20media%20thumbnail%20aesthetic%2C%20high%20contrast%20graphic%20style&width=800&height=450&seq=media-01&orientation=landscape',
  },
  {
    seq: 'media-02',
    title: '知名网红直播翻车现场，言论引发全网争议',
    views: '96.3万',
    time: '5小时前',
    duration: '05:12',
    tag: '网红圈',
    image: 'https://readdy.ai/api/search-image?query=Livestream%20drama%20moment%20thumbnail%2C%20internet%20celebrity%20controversy%20visual%2C%20dramatic%20red%20and%20orange%20tones%2C%20bold%20headline%20overlay%20style%2C%20social%20media%20trending%20topic%20graphic%2C%20high%20energy%20visual%20design&width=800&height=450&seq=media-02&orientation=landscape',
  },
  {
    seq: 'media-03',
    title: '综艺节目录制现场突遭意外，节目组紧急回应',
    views: '87.1万',
    time: '8小时前',
    duration: '02:48',
    tag: '综艺',
    image: 'https://readdy.ai/api/search-image?query=TV%20variety%20show%20unexpected%20moment%20thumbnail%2C%20dramatic%20scene%20visual%2C%20warm%20amber%20lighting%2C%20bold%20text%20overlay%20design%2C%20entertainment%20news%20graphic%20style%2C%20eye-catching%20composition&width=800&height=450&seq=media-03&orientation=landscape',
  },
  {
    seq: 'media-04',
    title: '年度最劲爆！某大牌代言人背后不为人知的秘密',
    views: '215.4万',
    time: '12小时前',
    duration: '08:56',
    tag: '爆料',
    image: 'https://readdy.ai/api/search-image?query=Exclusive%20scandal%20reveal%20thumbnail%2C%20breaking%20news%20visual%20style%2C%20dark%20mysterious%20atmosphere%20with%20coral%20accents%2C%20bold%20headline%20graphic%20design%2C%20dramatic%20lighting%2C%20high%20contrast%20composition&width=800&height=450&seq=media-04&orientation=landscape',
  },
];

export default function MediaSection() {
  return (
    <section id="media" className="py-14 md:py-20 bg-background-50">
      <div className="px-4 md:px-6 max-w-7xl mx-auto">
        <div className="text-center mb-10">
          <span className="inline-flex items-center gap-1.5 px-3 py-1 rounded-full bg-primary-100 text-primary-700 text-xs font-bold mb-4">
            <i className="ri-play-circle-line"></i>
            热门视频
          </span>
          <h2 className="text-2xl md:text-3xl font-heading font-black text-foreground-950 mb-3">
            最新吃瓜视频
          </h2>
          <p className="text-foreground-500 text-sm max-w-lg mx-auto">
            每日精选热门爆料视频，高清在线播放，给你第一手吃瓜体验
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-5">
          {videos.map((v) => (
            <a
              key={v.seq}
              href="#media"
              className="group block bg-background-100 rounded-xl overflow-hidden hover:shadow-lg transition-all duration-300"
            >
              <div className="relative aspect-video overflow-hidden bg-background-200">
                <img
                  src={v.image}
                  alt={`51吃瓜在线视频-${v.title}`}
                  className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
                  title={`51吃瓜在线观看-${v.title}`}
                />
                <div className="absolute inset-0 bg-gradient-to-t from-black/60 via-transparent to-transparent"></div>
                <div className="absolute bottom-3 right-3 bg-black/70 text-background-50 text-xs px-2 py-0.5 rounded-md font-mono">
                  {v.duration}
                </div>
                <div className="absolute top-3 left-3">
                  <span className="bg-primary-500 text-background-50 text-xs px-2 py-0.5 rounded-full font-bold">{v.tag}</span>
                </div>
                <div className="absolute inset-0 flex items-center justify-center opacity-0 group-hover:opacity-100 transition-opacity duration-300">
                  <div className="w-12 h-12 flex items-center justify-center bg-primary-500 rounded-full shadow-lg">
                    <i className="ri-play-fill text-background-50 text-xl ml-0.5"></i>
                  </div>
                </div>
              </div>
              <div className="p-4">
                <h3 className="text-sm font-bold text-foreground-900 line-clamp-2 leading-snug mb-2 group-hover:text-primary-600 transition-colors">
                  {v.title}
                </h3>
                <div className="flex items-center justify-between text-xs text-foreground-500">
                  <span><i className="ri-eye-line mr-1"></i>{v.views}</span>
                  <span>{v.time}</span>
                </div>
              </div>
            </a>
          ))}
        </div>
      </div>
    </section>
  );
}